var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c("div", { staticClass: "chat-modal" }, [
        _c("div", { staticClass: "chat-header-bar" }, [
          _c("div", { staticClass: "chat-header-info" }, [
            _vm.userInfo.userImageUrl
              ? _c("img", {
                  staticClass: "chat-header-avatar",
                  attrs: { src: _vm.userInfo.userImageUrl, alt: "" },
                })
              : _vm._e(),
            _c("div", { staticClass: "chat-header-text" }, [
              _c("h3", [_vm._v(_vm._s(_vm.userInfo.userName))]),
            ]),
          ]),
          _c(
            "button",
            {
              staticClass: "chat-close",
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_c("i", { staticClass: "el-icon-circle-close" })]
          ),
        ]),
        _c(
          "div",
          {
            ref: "messagesContainer",
            staticClass: "chat-messages",
            on: { scroll: _vm.handleScroll },
          },
          [
            _vm.isLoading
              ? _c("div", { staticClass: "chat-loading" }, [
                  _c("i", { staticClass: "el-icon-loading" }),
                  _vm._v(" 加载中... "),
                ])
              : _vm._e(),
            _vm._l(_vm.messageList, function (message) {
              return _c(
                "div",
                {
                  key: message.id,
                  class: [
                    "message-bubble",
                    message.position === "right" ? "sent" : "received",
                  ],
                },
                [
                  _c("div", [_vm._v(_vm._s(message.content))]),
                  _c("div", { staticClass: "message-time" }, [
                    _vm._v(_vm._s(_vm.getRelativeTime(message.sendTime))),
                  ]),
                ]
              )
            }),
          ],
          2
        ),
        _c("div", { staticClass: "chat-input-area" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newMessage,
                expression: "newMessage",
              },
            ],
            ref: "messageInput",
            staticClass: "chat-input",
            attrs: { placeholder: "输入消息...", type: "text" },
            domProps: { value: _vm.newMessage },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.sendMessage.apply(null, arguments)
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.newMessage = $event.target.value
              },
            },
          }),
          _c(
            "button",
            {
              staticClass: "send-btn",
              class: { disabled: !_vm.canSend, sending: _vm.isSending },
              attrs: { disabled: !_vm.canSend || _vm.isSending },
              on: { click: _vm.sendMessage },
            },
            [
              _c("i", {
                staticClass: "el-icon-s-promotion",
                class: { "send-animation": _vm.isSending },
              }),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }